import React, { useState } from "react";

function ProcessDataButton2({ width, deltaT, stepSize, deltaTUnit, stepSizeUnit, nodeData, unitIDData, setLoading, onDataUpdate, dataUnit }) {
  const [errorMessage, setErrorMessage] = useState("");

  const handleProcess = async () => {
    console.log("[DEBUG] Selected Data Unit:", dataUnit); // ✅ Check what unit is being used
  
    if (!nodeData || !unitIDData || !deltaT || !stepSize) {
      setErrorMessage("Missing required inputs");
      return;
    }
  
    setErrorMessage("");
    setLoading(true);
  
    // Unit conversion map (convert everything to the selected unit)
    const unitConversion = {
      "s": 1,       // ✅ seconds stay the same
      "m": 60,    // ✅ 1 min = 60s
      "h": 3600,    // ✅ 1 hour = 3600s
      "d": 86400    // ✅ 1 day = 86400s
    };
  
    console.log("[DEBUG] deltaT before conversion:", deltaT);
    console.log("[DEBUG] stepSize before conversion:", stepSize);
  
    // Convert deltaT and stepSize to match the selected unit (`dataUnit`)
    const convertedDeltaT = deltaT * unitConversion[deltaTUnit] / unitConversion[dataUnit]; 
    const convertedStepSize = stepSize * unitConversion[stepSizeUnit] / unitConversion[dataUnit];
  
    console.log("[DEBUG] Converted deltaT:", convertedDeltaT);
    console.log("[DEBUG] Converted stepSize:", convertedStepSize);  
  
    try {
      const requestBody = {
        delta_t: convertedDeltaT,  // ✅ Now in the selected unit
        step_size: convertedStepSize,  // ✅ Now in the selected unit
        node_data: nodeData,
        unitID_data: unitIDData,
        data_unit: dataUnit  // ✅ Indicate the unit used
      };
  
      const response = await fetch("https://recogtoolbox.se/api/process-data", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody)
      });
  
      if (!response.ok) {
        throw new Error(`Server error: ${response.status}`);
      }
  
      const responseData = await response.json();
      console.log("[DEBUG] Received response:", responseData);
      
      if (responseData.message === "JSON stored successfully") {
        onDataUpdate(responseData);  // ✅ Pass response to trigger redirect in SelectPage
      } else {
        setErrorMessage("Unexpected response from server.");
      }
  
    } catch (error) {
      console.error("Processing error:", error);
      setErrorMessage("Error processing request.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ ...styles.container, width: `${width}px` }}>
      <button onClick={handleProcess} style={styles.button}>Process Data</button>
      {errorMessage && <div style={styles.errorBox}>{errorMessage}</div>} {/* ✅ Show error if needed */}
    </div>
  );
}

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: "20px",
  },
  button: {
    padding: "10px 20px",
    fontSize: "16px",
    backgroundColor: "#007bff",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
  errorBox: {
    marginTop: "10px",
    padding: "10px",
    backgroundColor: "white",
    color: "red",
    fontWeight: "bold",
    textAlign: "center",
    border: "1px solid red",
    borderRadius: "5px",
    width: "100%",
  },
};

export default ProcessDataButton2;
